export default {
  "systemSetting.roles.section.collectionTypes": "集合类型",
  "systemSetting.roles.section.singleTypes": "单类型",
  "systemSetting.roles.section.plugins": "插件",
  "systemSetting.roles.section.settings": "设置",
  "systemSetting.roles.actions.create": "创建",
  "systemSetting.roles.actions.read": "读取",
  "systemSetting.roles.actions.update": "更新",
  "systemSetting.roles.actions.delete": "删除",
  "systemSetting.roles.actions.publish": "发布",
  "systemSetting.roles.loadFailed": "权限数据加载失败",
  "systemSetting.roles.simple.empty": "暂无可配置的操作",
  "systemSetting.roles.selectAll": "全选",
  "systemSetting.roles.fields": "字段",
  "systemSetting.roles.allSubjects": "所有内容",
  "systemSetting.roles.content.empty": "暂无可配置的内容类型",
  "systemSetting.roles.emptyData": "暂无权限数据",
  "systemSetting.roles.noSections": "没有可配置的权限分区",
  "systemSetting.roles.general": "通用",
  "systemSetting.roles.generalLower": "通用组",

  //权限分类Title

  "systemSetting.roles.section.plugins.strapi-cache": "缓存插件管理",
  "systemSetting.roles.section.plugins.user-admin-plugin": "用户菜单权限管理",

  //用户菜单权限管理 组名 subGroup
  "systemSetting.roles.subGroup.user-admin": "会员管理组",
  "systemSetting.roles.subGroup.withdraw-admin": "资金管理",
  "systemSetting.roles.subGroup.record-admin": "记录管理",
  "systemSetting.roles.subGroup.bonus-admin": "优惠管理",
  "systemSetting.roles.subGroup.statistical-reports": "统计报表",
  "systemSetting.roles.subGroup.agent-admin": "代理管理",
  "systemSetting.roles.subGroup.config-section": "配置管理",
  "systemSetting.roles.subGroup.game-admin": "游戏管理",
  "systemSetting.roles.subGroup.gem-mall-admin": "宝石商城管理",
  "systemSetting.roles.subGroup.pwa-notification-admin": "PWA通知管理",
  "systemSetting.roles.subGroup.payment-admin": "支付管理",
  "systemSetting.roles.subGroup.system-setting": "系统设置",

  "systemSetting.roles.permissions": "权限",
  "systemSetting.roles.section.plugins.content-manager": "内容管理器",
  "systemSetting.roles.section.plugins.content-type-builder": "内容管理器类型编辑",
  "systemSetting.roles.section.plugins.upload": "上传",
  "systemSetting.roles.section.plugins.seo": "SEO插件",
  "systemSetting.roles.section.plugins.users-permissions": "用户权限管理",

  "systemSetting.roles.section.settings.email": "邮件配置",
  "systemSetting.roles.section.settings.media library": "媒体库配置",
  "systemSetting.roles.section.settings.Internationalization": "国际化配置",
  "systemSetting.roles.section.settings.plugins and marketplace": "插件与插件市场",
  "systemSetting.roles.section.settings.webhooks": "Web Hooks",
  "systemSetting.roles.section.settings.users and roles": "用户和角色",
  "systemSetting.roles.section.settings.api tokens": "Api Tokens",
  "systemSetting.roles.section.settings.project": "Project",
  "systemSetting.roles.section.settings.transfer tokens": "Transfer Tokens",

  "systemSetting.roles.section.plugins.user-admin": "会员管理组",
  "systemSetting.roles.section.settings.users-permissions": "用户与权限",
  "systemSetting.roles.subGroup.single types": "单类型",
  "systemSetting.roles.action.plugin::content-manager.single-types.configure-view":
    "单类型配置",

  //缓存插件权限管理 具体字段
  "systemSetting.roles.action.plugin::strapi-cache.purge-cache": "缓存插件配置",
  //用户菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.setting-clear-cache.read": "缓存清理菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin.read": "会员管理菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin-user-list.read": "会员列表菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.export-user-list.read": "会员列表导出",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin-user-risk-admin.read": "会员风控管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin-user-tags-admin.read": "会员标签管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin-user-group-admin.read": "会员分组管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin-user-vip-admin.read": "会员VIP等级管理",

  //资金管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin.read": "资金管理菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-withdraw-approval-auto-withdraw.read": "允许自动审批开关",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-withdraw-approval-auto-withdraw.edit": "允许自动审批",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-withdraw-approval.read": "提款审批列表",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-withdraw-history.read": "会员提款记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-deposit-record.read": "会员存款",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-cash-transfer-record.read": "转账记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.export-deposit-record.read": "会员存款列表导出",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-wallet-record.read": "钱包记录",

  //记录管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin.read": "记录管理菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-wallet-change-list.read": "账变记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-bet-order.read": "投注记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-audit-record.read": "稽核记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-bonus-record.read": "奖金记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-redemption-code.read": "兑换码记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-checkin-record.read": "签到记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-freespin-record.read": "免费旋转记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-luckywheel-record.read": "幸运轮盘记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-activity-bonus-record.read": "活动奖金记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-login-history.read": "登录记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-sms-history.read": "SMS记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-sms-platform.read": "短信平台",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-sms-records.read": "短信记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-operation-record.read": "操作记录",

  //优惠管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin.read": "优惠管理菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-promotions-admin.read": "活动中心",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-bonus-approval.read": "优惠人工派发",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-activity-bonus-history.read": "活动奖励历史",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-redemption-code-config.read": "兑换码配置",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-free-spin-admin.read": "免费旋转配置",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-luckywheel-admin.read": "幸运转轮配置",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-activity-bonus-admin.read": "活动奖金配置",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-daily-rebate-admin.read": "每日返现管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-realtime-rebate-admin.read": "实时返现管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-invite-box-admin.read": "邀请宝箱管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-task-admin.read": "任务管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-luckydraw-config.read": "幸运抽奖配置",

  //统计报表菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports.read": "统计报表菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-daily-reports.read": "日报报表",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-user-reports.read": "用户报表",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-channel-reports.read": "渠道来源统计",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-ltv-reports.read": "LTV报表",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-k-factor": "K-Factor 报表",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-retention-rate.read": "留存率",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-retention-rate-bet.read": "留存率(投注口径)",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-retention-rate-deposit.read": "留存率(存款口径)",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-retention-rate-v-three.read": "留存率V3",

  // 消息管理
  "systemSetting.roles.action.plugin::user-admin-plugin.message-admin.read": "消息管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.message-admin-message.read": "消息类型管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.message-admin-notification.read": "弹框消息图片类型管理",

  //代理管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin.read": "代理管理菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin-agent-approval.read": "代理审批",
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin-agent-history.read": "代理审批记录",
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin-agent-details.read": "代理详情",
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin-agent-report.read": "代理报表",
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin-agent-cashback-admin.read": "代理反现管理",

  //配置管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section.read": "配置管理菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-adjust-app-config.read": "AdjustAPP配置",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-about-admin.read": "关于我们管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-left-menu-admin.read": "左侧菜单配置",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-pixels-management.read": "像素管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-airdrop-config.read": "红包雨配置",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-email-marketing.read": "邮件营销",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-message-admin.read": "消息管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-valid-bet-config.read": "有效投注管理",

  //游戏管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.game-admin.read": "游戏管理菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.game-admin-games-manege.read": "游戏列表",
  "systemSetting.roles.action.plugin::user-admin-plugin.game-admin-game-actions.read": "游戏操作",
  "systemSetting.roles.action.plugin::user-admin-plugin.game-admin-tags-admin.read": "标签管理",


  //宝石商城管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.gem-mall-admin.read": "宝石商城管理菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.gem-mall-admin-goods-type-admin.read": "宝石商品类型管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.gem-mall-admin-goods-admin.read": "宝石商品管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.gem-mall-admin-exchange-mall-admin.read": "宝石兑换商城管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.gem-mall-admin-exchange-tags-admin.read": "宝石兑换商城标签管理",

  //PWA通知管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.pwa-notification-admin.read": "PWA通知管理菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.pwa-notification-admin-pwa-device-list.read": "PWA设备列表",
  "systemSetting.roles.action.plugin::user-admin-plugin.pwa-notification-admin-list.read": "PWA通知列表",
  "systemSetting.roles.action.plugin::user-admin-plugin.pwa-notification-admin-task-list.read": "PWA通知任务列表",

  //支付管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.payment-admin.read": "支付管理菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.payment-admin-payment-platform-admin.read": "三方支付平台管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.payment-admin-pay-type.read": "支付方式管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.payment-admin-pay-wap-bank.read": "支付渠道配置管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.payment-admin-withdraw-type.read": "出款方式管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.payment-admin-withdraw-channel.read": "出款渠道配置管理",

  //系统设置管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.system-setting.read": "系统设置菜单",
  "systemSetting.roles.action.plugin::user-admin-plugin.system-setting-user-admin.read": "系统用户管理",
  "systemSetting.roles.action.plugin::user-admin-plugin.system-setting-roles-admin.read": "系统角色管理",


};
